import React, { ReactNode } from 'react';
// @ts-ignore
import { useTabIndex } from 'react-tabindex';
import styled from 'styled-components';
import { SelectedIcon } from './SelectedIcon';

type Props = {
  children?: ReactNode;
  isSelected: boolean;
  isAltStyle?: boolean;
  noCol?: number;
  onClick: () => void;
  isBracketOption?: boolean;
};

const StyledButton = styled.div<{ isSelected: boolean; noCol: number; isBracketOption?: boolean; }>`
  background-color: white;
  border-radius: 10px;
  cursor: pointer;
  padding: 16px;
  position: relative;
  text-align: center;
  margin: 0.5rem 0.5rem;
  display: block;
  text-transform: capitalize;
  font: normal normal normal 14px/17px Lato;
  color: #242325;

  ${({ isBracketOption }) => {
    if (isBracketOption) {
      return `
      flex: 0 0 calc(25% - 10px) !important;
      padding: 12px 22px !important;
      margin: 0 !important;
      display: flex !important;
      justify-content: center !important;
      align-items: center !important;
      `;
    }
  }}

  flex-basis: ${({ noCol }) => {
    return `calc(${100 / noCol}% - 1rem)`;
  }};

  max-width: ${({ noCol }) => {
    return `calc(${100 / noCol}% - 1rem)`;
  }};

  border: ${({ isSelected }) => {
    const borderNormal = `1.5px solid #DADEE2`;
    const borderSelected = `1.5px solid #26375F`;
    return isSelected ? borderSelected : borderNormal;
  }};

  box-shadow: ${({ isSelected }) => {
    const boxShadowNormal = `0 0 0 1px #DADEE2`;
    const boxShadowSelected = `0 0 0 1px #26375F`;
    return isSelected ? boxShadowSelected : boxShadowNormal;
  }};

  &:hover {
    background-color: rgba(0, 0, 0, 0.05);
    border: 1.5px solid #26375f;
  }

  &:focus {
    outline: 0;
  }

  @media (max-width: 767px) {
    ${({ isBracketOption, isSelected }) => {
    if (isBracketOption && !isSelected) {
      return `padding: 7px 10px !important;
        font: 10px / 17px Lato;`;
    } else return `font: 11px / 17px Lato;
      padding: 7px 22px !important;`
    }}
  }

  @media (max-width: 374px) {
    ${({ isBracketOption, isSelected }) => {
    if (isBracketOption && !isSelected) {
      return ` font: 10px / 17px Lato;;
    padding: 7px 6px !important;`;
    } else return `font: 10px / 17px Lato;
    padding: 7px 20px !important;`
    }}
  }
`;

const SelectorItem = ({
  children,
  isSelected,
  isAltStyle,
  noCol = 1,
  onClick = () => {},
  isBracketOption
}: Props) => {
  const tabIndex: number = useTabIndex();
  return (
    <StyledButton
      noCol={noCol}
      tabIndex={tabIndex}
      isSelected={isSelected}
      onClick={onClick}
      isBracketOption={isBracketOption}
    >
      {isSelected && <SelectedIcon isAltStyle={isAltStyle} isBracketOption={isBracketOption} />}
      {children}
    </StyledButton>
  );
};

export default SelectorItem;
